import React, { createContext, useReducer } from 'react'
import notificationReducer from './notificationReducer'
import { SET_NOTIFICATION, SET_PROMPT } from '../types'

const NotificationContext = createContext()

const NotificationState = ({ children }) => {
  const initialState = {
    notification: {
      message: "",
      type: "toast",
      variant: "info",
      show: false,
    },
    prompt: {
      message: "",
      buttons: [],
      show: false,
      onClose: () => {
        closePrompt()
      }
    },
  }

  const [state, dispatch] = useReducer(notificationReducer, initialState)

  const toast = ({ message, variant = 'info', timeout = 4000 }) => {
    setNotification({ message, type: 'toast', variant, show: true })
    setTimeout(() => {
      setNotification({ message, type: 'toast', variant, show: false })
    }, timeout)
  }

  const prompt = ({ message, buttons }) => {
    return new Promise((resolve, reject) => {
      setPrompt({
        message,
        buttons: buttons.map(button => ({
          ...button,
          action: () => {
            closePrompt()
            resolve(button.value)
          }
        })),
        show: true,
        onClose: () => {
          closePrompt()
          resolve('cancel')
        }
      })
    })
  }

  const closePrompt = () => {
    setPrompt({ ...state.prompt, show: false })
  }

  const setNotification = (notification) => {
    dispatch({ type: SET_NOTIFICATION, payload: notification })
  }

  const setPrompt = (prompt) => {
    dispatch({ type: SET_PROMPT, payload: prompt })
  }

  const showToast = () => {
    return state.notification.show && state.notification.type === 'toast'
  }

  return (
    <NotificationContext.Provider value={{
      toast,
      prompt
    }}>
      {children}
      <div className={`notification-root w-full`}>
        <div className={`notification-toast ${state.notification?.variant} ${showToast() ? '' : 'hidden'}`}>
          <span>{state.notification?.message}</span>
        </div>
        <div className={`notification-prompt ${state.prompt?.show ? '' : 'hidden'}`}>
          <div className={`notification-prompt__overlay`} onClick={state.prompt?.onClose}></div>
          <div className={`notification-prompt__container`}>
            <button
              className="p-1 bg-transparent text-black text-3xl absolute top-2 right-4"
              onClick={state.prompt?.onClose}
            >
              ×
            </button>
            <div className={`notification-prompt__body`}>
              <span>{state.prompt?.message}</span>
              <div className='notification-prompt__buttons'>
                {state.prompt?.buttons.map((button, index) => (
                  <button className={`mid flex ${button.variant}`} key={index} onClick={button.action}>{button.label}</button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </NotificationContext.Provider>
  )
}

export default NotificationState
export { NotificationContext }